var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mb-8"},[_c(_setup.CreateCollection,{on:{"created":_setup.onCollectionCreated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }